<div class="container_herramienta">
  <!-- <img src="assets/img/web/cotiza.webp" class="img_toAnimate"> -->
  <div class="alinearIzq">
    <div class="container-contenido">
      <div class="formulario" id="">
        <div [formGroup]="cotizaForm" novalidate="" class="main fade-in">

          <h1>Cotizar envío</h1>
          <h6>Use esta sencilla herramienta para obtener una tarifa estimada del costo de tu proximo envío.</h6>
          <div class="inputs">
            <div class="sucursal">
              <!-- <label>Origen</label> -->
              <ng-select
                [ngClass]="{'error' : (cotizaForm.get('origen').invalid || cotizaForm.get('origen').value === '0') && submitted }"
                [items]="ciudades" bindLabel="sucursal" bindValue="cp" appendTo="body" [multiple]="false"
                [clearable]="false" [editableSearchTerm]="false" [virtualScroll]="true" notFoundText="No se encontro"
                formControlName="origen">
              </ng-select>
            </div>

            <div class="sucursal">
              <!-- <label>Destino</label> -->
              <ng-select
                [ngClass]="{'error' : (cotizaForm.get('origen').invalid || cotizaForm.get('origen').value === '0') && submitted }"
                [items]="ciudades" bindLabel="sucursal" bindValue="cp" appendTo="body" [multiple]="false"
                [clearable]="false" [editableSearchTerm]="false" [virtualScroll]="true" notFoundText="No se encontro"
                formControlName="destino">
              </ng-select>
            </div>
            <div class="formbtncotizar">
              <button class="btnCotizar" id="cotizar" (click)="getCotizacion()">
                Cotizar envío
                <svg id="cotizar1" class="material-icons" height="24" viewBox="0 0 24 24" width="24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#FFFF" id="cotizar2">
                  </path>
                  <path d="M0 0h24v24H0z" fill="none" id="cotizar3"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

  <div class="container-slider-promo">
    <div class="content-slider">
      <div id="carouselPromos" class="carousel carousel-dark slide carousel-fx" data-bs-ride="carousel">
        <div class="carousel-inner" style="border-radius: 20px !important;">

          <!-- POPUP SLIDER 0 (23s) -->
          <!-- <div class="carousel-item" data-bs-interval="23000">
          <video class="promo-video" playsinline webkit-playsinline loop preload="auto">
            <source src="assets/img/videos-promos/videoNavidad_dskp.mp4" type="video/mp4">
          </video>
        
          <button type="button" class="btn-audio" (click)="toggleSoundFirstSlideDesktop($event)">
            <span *ngIf="!isSoundOnFirstSlideDesktop" title="Activar sonido">🔇</span>
            <span *ngIf="isSoundOnFirstSlideDesktop" title="Silenciar">🔊</span>
          </button>
        
          <button class="btn_slide fadeInRightFast" appVisibility routerLink="/promocion"
            [queryParams]="{ code: 'promonavidad2025'}"
            (click)="onSlideClick('click_slideHome_navidad_desktop', '/promocion?code=promonavidad2025', 'desktop')">
            <img src="assets/img/videos-promos/icon_promoNavidad.png">Ver Promoción
          </button>
        </div> -->

          <!-- POPUP SLIDER 0 (7s) -->
          <!-- <div class="carousel-item active" data-bs-interval="7000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="metadata">
              <source src="assets/img/videos-promos/Mandaygana_deskop.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast"
                    appVisibility
                    routerLink="/promocion"
                    [queryParams]="{ code: 'manda-y-gana'}"
                    (click)="onSlideClick('click_slideHome_manda-y-gana_deskop', '/promocion?code=manda-y-gana', 'desktop')">
              <img src="assets/img/videos-promos/icon_promoMandayGana.png">¡Saber más!
            </button>
          </div> -->
          <div class="carousel-item active" data-bs-interval="9000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
              <source src="assets/img/videos-promos/gamaguiasweb_dskp.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast" appVisibility routerLink="/guias-web2"
              (click)="onSlideClick('click_slideHome_guiasweb2_desktop', '/guias-web2', 'desktop')">
              <img src="assets/img/videos-promos/icon_gamasguiasweb.webp">¡Más información!
            </button>
          </div>

          <!-- POPUP SLIDER 1 (7s) -->
          <div class="carousel-item" data-bs-interval="7000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
              <source src="assets/img/videos-promos/PaKGanes_dskp.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast" appVisibility routerLink="/PaKGanes"
              (click)="onSlideClick('click_slideHome_pakganes_desktop', '/PaKGanes', 'desktop')">
              <img src="assets/img/videos-promos/icon_pakGanes.webp">¡Quiero Invitar!
            </button>
          </div>

          <!-- POPUP SLIDER 2 (7s) -->
          <div class="carousel-item" data-bs-interval="8000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
              <source src="assets/img/videos-promos/redactiva_deskp.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast" appVisibility routerLink="/red-activa"
              (click)="onSlideClick('click_slideHome_redactiva_desktop', '/red-activa' , 'desktop')">
              <img src="assets/img/videos-promos/icon_redActiva.webp">¡Cotiza aquí!
            </button>
          </div>

          <!-- POPUP SLIDER 3 (7s) -->
          <div class="carousel-item" data-bs-interval="8000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
              <source src="assets/img/videos-promos/Guiasweb_deskp.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast" appVisibility routerLink="/guias-web"
              (click)="onSlideClick('click_slideHome_guiasweb_desktop', '/guias-web' , 'desktop')">
              <img src="assets/img/videos-promos/icon_guiasWeb.webp">Más información
            </button>
          </div>

          <!-- POPUP SLIDER 4 (5s) -->
          <div class="carousel-item" data-bs-interval="5000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
              <source src="assets/img/videos-promos/tfpHoras_dskp.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast" appVisibility routerLink="/tufesapack-horas"
              (click)="onSlideClick('click_slideHome_tfpHoras_desktop', '/tufesapack-horas' , 'desktop')">
              <img src="assets/img/videos-promos/icon_tfpHoras.webp">¡Conócelo!
            </button>
          </div>

          <!-- POPUP SLIDER 5 (6s) -->
          <div class="carousel-item" data-bs-interval="6000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
              <source src="assets/img/videos-promos/recoleccion_dskp.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast" appVisibility routerLink="/promocion"
              [queryParams]="{ code: 'promohermosillo'}"
              (click)="onSlideClick('click_slideHome_recoleccion_desktop', '/promocion?code=promohermosillo', 'desktop')">
              <img src="assets/img/videos-promos/icon_recoleccion.webp">Haz clic aquí
            </button>
          </div>

          <!-- POPUP SLIDER 6 (5s) -->
          <div class="carousel-item" data-bs-interval="5000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
              <source src="assets/img/videos-promos/paktCambies_dskp.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast" appVisibility routerLink="/PaKTCambies"
              [queryParams]="{ code: 'PROMOPKTCAM25'}"
              (click)="onSlideClick('click_slideHome_pktcambies_desktop', '/PaKTCambies?code=PROMOPKTCAM25', 'desktop')">
              <img src="assets/img/videos-promos/icon_pktCambies.webp">¡Cámbiate aquí!
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div appVisibility class="container-slider-promo-mobil zoomIn">
    <div class="content-img-promo" (click)="mostrarmodalmobil()">
      <img src="assets/img/videos-promos/img_hazClic.jpg">
    </div>
  </div>

  <!-- Fondo del popup -->
  <div class="overlay" [class.open]="showModal" (click)="close()">

    <!-- Contenedor del popup -->
    <div class="container_popup_slider popup" (click)="$event.stopPropagation()">

      <!-- Botón para cerrar -->
      <button class="btn-close closep" (click)="close()">✕</button>

      <!-- Contenido del slider -->
      <div class="content-slider">
        <div id="carouselPromos2" class="carousel carousel-dark slide carousel-fx" data-bs-ride="carousel">
          <div class="carousel-inner" style="border-radius: 20px !important;">

            <!-- POPUP SLIDER 0 (7s) -->
            <!-- <div class="carousel-item active" data-bs-interval="7000">
            <video class="promo-video" muted playsinline webkit-playsinline loop preload="metadata">
              <source src="assets/img/videos-promos/Mandaygana_mobil.mp4" type="video/mp4">
            </video>
            <button class="btn_slide fadeInRightFast"
                    appVisibility
                    routerLink="/promocion"
                    [queryParams]="{ code: 'manda-y-gana'}"
                    (click)="onSlideClick('click_slideHome_manda-y-gana_mobile', '/promocion?code=manda-y-gana', 'mobile')">
              <img src="assets/img/videos-promos/icon_promoMandayGana.png">¡Saber más!
            </button>
          </div> -->

            <div class="carousel-item active" data-bs-interval="9000">
              <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
                <source src="assets/img/videos-promos/gamaguiasweb_mobil.mp4" type="video/mp4">
              </video>
              <button class="btn_slide fadeInRightFast" appVisibility routerLink="/guias-web2"
                (click)="onSlideClick('click_slideHome_guiasweb2_mobile', '/guias-web2', 'mobile')">
                <img src="assets/img/videos-promos/icon_gamasguiasweb.webp">¡Más información!
              </button>
            </div>

            <!-- POPUP SLIDER 1 (7s) -->
            <div class="carousel-item" data-bs-interval="7000">
              <video class="promo-video" muted playsinline webkit-playsinline loop preload="metadata">
                <source src="assets/img/videos-promos/PaKGanes_mobil.mp4" type="video/mp4">
              </video>
              <button class="btn_slide fadeInRightFast" appVisibility routerLink="/PaKGanes"
                (click)="onSlideClick('click_slideHome_pakganes_mobile', '/PaKGanes', 'mobile')">
                <img src="assets/img/videos-promos/icon_pakGanes.webp">¡Quiero Invitar!
              </button>
            </div>

            <!-- POPUP SLIDER 2 (7s) -->
            <div class="carousel-item" data-bs-interval="8000">
              <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
                <source src="assets/img/videos-promos/redactiva_mobil.mp4" type="video/mp4">
              </video>
              <button class="btn_slide fadeInRightFast" appVisibility routerLink="/red-activa"
                (click)="onSlideClick('click_slideHome_redactiva_mobile', '/red-activa', 'mobile')">
                <img src="assets/img/videos-promos/icon_redActiva.webp">¡Cotiza aquí!
              </button>
            </div>

            <!-- POPUP SLIDER 3 (8s) -->
            <div class="carousel-item" data-bs-interval="8000">
              <video class="promo-video" muted playsinline webkit-playsinline loop preload="metadata">
                <source src="assets/img/videos-promos/Guiasweb_mobil.mp4" type="video/mp4">
              </video>
              <button class="btn_slide fadeInRightFast" appVisibility routerLink="/guias-web"
                (click)="onSlideClick('click_slideHome_guiasweb_mobile', '/guias-web', 'mobile')">
                <img src="assets/img/videos-promos/icon_guiasWeb.webp">Más información
              </button>
            </div>

            <!-- POPUP SLIDER 4 (5s) -->
            <div class="carousel-item" data-bs-interval="5000">
              <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
                <source src="assets/img/videos-promos/tfpHoras_mobil.mp4" type="video/mp4">
              </video>
              <button class="btn_slide fadeInRightFast" appVisibility routerLink="/tufesapack-horas"
                (click)="onSlideClick('click_slideHome_tfp_horas_mobile', '/tufesapack-horas', 'mobile')">
                <img src="assets/img/videos-promos/icon_tfpHoras.webp">¡Conócelo!
              </button>
            </div>

            <!-- POPUP SLIDER 5 (6s) -->
            <div class="carousel-item" data-bs-interval="6000">
              <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
                <source src="assets/img/videos-promos/recoleccion_mobil.mp4" type="video/mp4">
              </video>
              <button class="btn_slide fadeInRightFast" appVisibility routerLink="/promocion"
                [queryParams]="{ code: 'promohermosillo'}"
                (click)="onSlideClick('click_slideHome_recoleccion_mobile', '/promocion?code=promohermosillo', 'mobile')">
                <img src="assets/img/videos-promos/icon_recoleccion.webp">Haz clic aquí
              </button>
            </div>

            <!-- POPUP SLIDER 6 (5s) -->
            <div class="carousel-item" data-bs-interval="5000">
              <video class="promo-video" muted playsinline webkit-playsinline loop preload="auto">
                <source src="assets/img/videos-promos/paktCambies_mobil.mp4" type="video/mp4">
              </video>
              <button class="btn_slide fadeInRightFast" appVisibility routerLink="/PaKTCambies"
                [queryParams]="{ code: 'PROMOPKTCAM25'}"
                (click)="onSlideClick('click_slideHome_pktcambies_mobile', '/PaKTCambies?code=PROMOPKTCAM25', 'mobile')">
                <img src="assets/img/videos-promos/icon_pktCambies.webp">¡Cámbiate aquí!
              </button>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>